import * as React from 'react';

export interface IDtpHeaderProps {
    mainTitle: string;
    subTitle: string;
}

export const DtpHeader = (props: IDtpHeaderProps) => {
    return (
        <div className="dtp-portal-header">
            <div className="header-logo">
                <div className="logo">
                    <img src="/tronlogo_HW_250.png" />
                </div>
            </div>
            <div className="header-title">
                <div className="title">
                    <h3>{props.mainTitle}</h3>
                    <h5>{props.subTitle}</h5>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/App/dtp-portal/dtp-header.component.tsx